import { render, staticRenderFns } from "./RawMaterialAddToFormulationPopUp.vue?vue&type=template&id=caf4a738&scoped=true&"
import script from "./RawMaterialAddToFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./RawMaterialAddToFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialAddToFormulationPopUp.vue?vue&type=style&index=0&id=caf4a738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf4a738",
  null
  
)

export default component.exports